import { useWindowDimensions } from 'react-native';

import { IWebviewProps } from 'pages/campaigns/types';
import { theme } from 'styles/configure-theme';

import { listenToMessagesFromOrigin } from './listeners';

export const WebView = ({
  onMessageReceived,
  externalUrl,
  onLoadEnd,
  webViewRef,
  backgroundColor,
  queryParam,
}: IWebviewProps) => {
  const { width } = useWindowDimensions();

  const handleIframeOnLoad = () => {
    listenToMessagesFromOrigin(onMessageReceived, new URL(externalUrl).origin);
    onLoadEnd();
  };

  return (
    <div style={{ height: 'calc(var(--real-vh, 1vh) * 100)' }}>
      <iframe
        title="external-campaign"
        src={`${externalUrl}${queryParam}`}
        onLoad={handleIframeOnLoad}
        ref={webViewRef as React.RefObject<HTMLIFrameElement>}
        height={window.innerHeight}
        allow="clipboard-write; web-share; fullscreen"
        style={{
          border: 0,
          backgroundColor: backgroundColor || theme.token('background-default'),
          height: window.innerHeight,
          width,
        }}
      ></iframe>
    </div>
  );
};
